import React from "react";
import {IProject} from "../../models/interfaces/project.interface.ts";
import {useProject} from "../../hooks/useProject.ts";
import ProgressBar from "../ProgressBar.tsx";

interface ProjectDrawerOverallProgressProps {
  project: IProject;
}

const ProjectDrawerOverallProgress: React.FC<ProjectDrawerOverallProgressProps> = ({project}: ProjectDrawerOverallProgressProps) => {
  const {calculateProjectPercentage} = useProject();
  const projectPercentage: number | null = calculateProjectPercentage(project);
  return (
    <>
      <div className="text-xl text-n-200 font-semibold mb-6 ">Feature Progress</div>
      <div className="flex flex-col">
        <span>Overall progress</span>
        <ProgressBar percentage={projectPercentage}/>
      </div>
    </>
  )
}

export default ProjectDrawerOverallProgress;